import './DeliveryEstimate.css';
import { useState } from 'react';
import { commerceRequest } from '../../lib/commerceApi';
import { money } from '../../lib/format';
import { DeliveryEstimate as Estimate } from '../../types/commerce';
import { PIN_CODE_REGEX } from '../../lib/constants';
export default function DeliveryEstimate() {
  const [pin, setPin] = useState('');
  const [result, setResult] = useState<Estimate | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    setError('');
    setResult(null);
    try {
      setResult(await commerceRequest<Estimate>(`/commerce/delivery?pin=${encodeURIComponent(pin)}`));
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not check delivery');
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="delivery-estimate" aria-label="Delivery estimate">
      <label>
        Delivery PIN code{' '}
        <input
          inputMode="numeric"
          maxLength={6}
          value={pin}
          onChange={(e) => {
            setPin(e.target.value);
            setResult(null);
          }}
        />
      </label>{' '}
      <button type="button" disabled={busy || !PIN_CODE_REGEX.test(pin)} onClick={() => void check()}>
        {busy ? 'Checking…' : 'Check delivery'}
      </button>
      {error && <p role="alert">{error}</p>}
      {result && (
        <p role="status">
          {result.serviceable
            ? `Delivered by ${result.latest} · Transportation ${money(result.fee_paise ?? 0)}`
            : result.explanation}
        </p>
      )}
    </section>
  );
}
